import SandboxBanner from './SandboxBanner';

export default SandboxBanner;
